import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { UploadService } from 'src/app/service/upload.service';
import Speech from 'speak-tts';

@Component({
  selector: 'app-review-question',
  templateUrl: './review-question.component.html',
  styleUrls: ['./review-question.component.scss']
})
export class ReviewQuestionComponent implements OnInit {

  @Input('question') public question: any = {};
  original_answers_ids: any = [];
  @Output() reviewedItem = new EventEmitter();
  speech = new Speech(); // will throw an exception if not browser supported

  constructor(
    public uploadService: UploadService,
    public _lightbox: Lightbox,
  ) {
  }

  speechConfig() {
    if (this.speech.hasBrowserSupport()) {
      console.log('speech synthesis supported');
    }
    this.speech
      .init()
      .then(data => {
        console.log('Speech is ready, voices are available', data);
      })
      .catch(e => {
        console.error('An error occured while initializing : ', e);
      });
  }

  ngOnInit() {
  }

  open(image_path): void {
    var _albums = [];
    const album = {
      src: image_path,
      caption: '',
      thumb: image_path
    };
    _albums.push(album);
    // open lightbox
    this._lightbox.open(_albums, 0);
  }

  readSentance(sentance) {
    this.speech
      .speak({
        text: sentance
      })
      .then(() => {
        console.log('Success !');
      })
      .catch(e => {
        console.error('An error occurred :', e);
      });
  }

  reviewItem(event) {
    this.reviewedItem.emit(event);
  }

}
